<app-dialog [size]="dialogSize">
  <app-dialog-header [showClose]="false">Application error</app-dialog-header>
  <div><p>The requested section of the application has failed to load, and the page must be reloaded in order to view it</p></div>
  <app-dialog-footer [isAlert]="true" [showCancel]="false">
    <button [mat-dialog-close]="true" andButton color="primary">Reload</button>
  </app-dialog-footer>
</app-dialog>
